<template>
  <base-section
    id="fringe-workshops"
  >

    <base-section-heading title="Fringe Workshops">
    </base-section-heading>
    <v-container>
      <base-section-heading
      divider=null
      >
        ETS'23 workshops will last for one and a half days, starting on <strong>Thursday, May 25</strong>, immediately after the ETS'23 closing session (around 16:00), and carry through until <strong>Friday, May 26 </strong> (around 16:00).
        <!---Workshop registration will be facilitated via the ETS'23 registration site.--->
        <br>
        <br>
        ETS 2023 will have three co-located workshops:
        <br>
        - <span style="color: #204165;"><strong>AI-TREATS</strong>: 3rd IEEE Workshop on AI Hardware: Test, Reliability and Security </span> <br>
        - <span style="color: #204165;"><strong>eARTS</strong>: European Automotive, Reliablity, Test and Safety Workshop </span><br>
        - <span style="color: #204165;"><strong>IMTR</strong>: Workshop on Intelligent Methods for Test and Reliability (IMTR'23) </span><br>
        <br>
        <v-row>
          <v-col
          cols="12"
          sm="12"
          md="4"
          >
            <v-btn
              href="https://ai-treats-workshop.aalto.fi/"
              target="_blank"
              rounded
              color="success"
              dark
              style="padding: 15px"
            >
              <v-icon
                left
                dark
              >
                mdi-open-in-new
              </v-icon>
              AI-TREATS
            </v-btn>
          </v-col>
          <v-col
          cols="12"
          sm="12"
          md="4"
          >
            <v-btn
              href="https://cas.polito.it/eARTS2023/"
              target="_blank"
              rounded
              color="success"
              dark
              style="padding: 15px"
            >
              <v-icon
                left
                dark
              >
                mdi-open-in-new
              </v-icon>
              eARTS
            </v-btn>
          </v-col>
          <v-col
          cols="12"
          sm="12"
          md="4"
          >
            <v-btn
              href="https://www.gs-imtr.uni-stuttgart.de/imtr23/"
              target="_blank"
              rounded
              color="success"
              dark
              style="padding: 15px"
            >
              <v-icon
                left
                dark
              >
                mdi-open-in-new
              </v-icon>
              IMTR
            </v-btn>
          </v-col>
        </v-row>
        <br>
        <br>
        <v-btn
          href="#/program#tab-topics"
          target="_parent"
          rounded
          color="primary"
          dark
          style="padding: 15px"
          v-if="!isMobileDevice()"
        >
          <v-icon
            left
            dark
          >
            mdi-open-in-new
          </v-icon>
          List of the Topics
        </v-btn>
        <v-btn
          href="#/topics"
          target="_parent"
          rounded
          color="primary"
          dark
          style="padding: 15px"
          v-else
        >
          <v-icon
            left
            dark
          >
            mdi-open-in-new
          </v-icon>
          List of the Topics
        </v-btn>
        <br>
        <br>
        A fringe workshop may cover, but is not limited to, the list of topics related to the ETS core scientific areas as outlined in the ETS'23 Call for Papers.
        <br>
        <br>
        If you want to registrate <strong>only for workshops</strong>, you have to select Workshop Registration 0€ as category and then select the workshop you want to attend in the "extras" (see <a
        href="only_ws_registration.png"
        download
        >
        screenshot</a>).
      </base-section-heading>
      <base-section-heading
      title="Tentative Schedule"
      >
      <div style="text-align: left !important">
      <strong>Thursday, 4:00-6:30 PM </strong><br>
      &emsp;&emsp;● Welcome Reception at 7 PM <br>
      <strong>Friday, 8:30-4:00 PM </strong><br>
      &emsp;&emsp;● Coffee Break (10 - 10:30 AM) <br>
      &emsp;&emsp;● Lunch Break (12:30 - 13:30 PM) <br>
      </div>
      </base-section-heading>
      <!---
      <base-section-heading
      title="Key Dates"
      >
      <v-data-table
        :headers="headers"
        :items="dates"
        :items-per-page="-1"
        item-key="name"
        hide-default-footer
        class="elevation-1"
      ></v-data-table>
      <br>
      </base-section-heading>
      --->
      <!---
      <base-section-heading
      title="Publications"
      >
      Workshop papers typically will not be included in the ETS’23 proceedings. However, this year, the conference organizers are providing an option to have the best papers to be included in the proceeding. This option applies only to the workshops that require a rigorous review process and is subject to the discretion of the ETS’23 organizers. Please sketch the planned review process and indicate interest in planning to select the best workshop paper to be included in the ETS’23 proceedings, as required by the workshop proposal submission template.
      </base-section-heading>
      --->
      <base-section-heading
      title="Contacts"
      >
      <v-row>
        <v-col
          v-for="(fringe, i) in fringes"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="fringe"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      </base-section-heading>
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in workshopsfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < workshopsfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
      </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'FringeWorkshops',

    data: () => ({
      isMobile: false,
      workshopsfooter: [
        {
          name: 'Fringe Workshops',
          url: 'fringe-workshops',
        },
        {
          name: 'AI-Treats',
          url: 'ai-treats',
        },
        {
          name: 'eARTS',
          url: 'e-arts',
        },
        {
          name: 'IMTR',
          url: 'imtr',
        },
      ],
      headers: [
        {
          text: 'Deadline Date',
          value: 'date',
          sortable: false,
          align: 'right',
        },
        {
          text: 'Type',
          value: 'name',
          sortable: false,
          align: 'left',
        },
      ],
      dates: [
        {
          name: 'Workshops Papers submission deadline',
          date: '15 February 2023',
        },
        {
          name: 'Authors notification',
          date: '1 April 2023',
        },
        {
          name: 'Camera-ready manuscript',
          date: '1 May 2023',
        },
      ],
      fringes: [
        {
          title: 'Prof. Alessandro Savino',
          src: require('@/images/committees/alessandrosavino.jpg'),
          text: 'Politecnico di Torino, IT, alessandro.savino@polito.it',
        },
        {
          title: 'Prof. Yanjing Li',
          src: require('@/images/committees/Li.jpg'),
          text: 'University of Chicago, US, yanjingl@uchicago.edu',
        },
      ],
    }),
    mounted () {
      //  this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
  }
</script>
